import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.some";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry, Jeremy Levy
*/
import React from 'react';
import SvgIcon from '../../svg-icon/SvgIcon';
import accessibleIcon from '../../accessible-icon/accessible-icon';
import useBrand from '../../hooks/use-brand';
import useDevice from '../../hooks/use-device';
import { getClasses } from '../../../lib/style-utils/style-utils';
import MastheadContext from '../../masthead/MastheadContext';
import styles from './WellsFargoLogo.less';
var responsiveLogoSizes = {
  sm: {
    width: '148px',
    height: '16px'
  },
  md: {
    width: '169px',
    height: '18px'
  },
  lg: {
    width: '211px',
    height: '22px'
  }
};
var responsiveLogoScales = {
  sm: {
    x: '1',
    y: '1'
  },
  md: {
    x: '1.14189',
    y: '1.125'
  },
  lg: {
    x: '1.430',
    y: '1.440'
  }
};
var path = "\n  M31.5783,10.22 L33.0183,10.22 L33.0183,15 L20.9983,15 L20.9983,13.26 L22.6983,13.26 L22.6983,2.74 L19.94,2.74 L16.44,15 L13.66,15 L10.82,4.84\n  L7.9,15 L5.12,15 L1.6,2.74 L0,2.74 L0,1 L6.52,1 L6.52,2.74 L4.64,2.74 L6.98,11.18 L9.78,1 L12.66,1 L15.52,11.2 L17.82,2.74 L15.86,2.74 L15.86,1\n  L32.8185,1 L32.8185,5.54 L31.3785,5.54 L31.2385,5 C30.7985,3.32 30.3385,2.74 28.9985,2.74 L25.6785,2.74 L25.6785,6.96 L29.6985,6.96 C29.8509872,7.25655731\n  29.9266299,7.5866346 29.9185,7.92 C29.9289227,8.26639109 29.8533362,8.60996586 29.6985,8.92 L25.6785,8.92 L25.6785,13.26 L29.1385,13.26 C30.4385,13.26\n  31.0185,12.7 31.4185,10.92 L31.5783,10.22 Z M44.2172,10.92 C43.8172,12.7 43.2572,13.26 41.9372,13.26 L39.1572,13.26 L39.1572,2.74 L41.0572,2.74 L41.0572,1\n  L34.4772,1 L34.4772,2.74 L36.1772,2.74 L36.1772,13.26 L34.4772,13.26 L34.4772,15 L45.8172,15 L45.8172,10.22 L44.3772,10.22 L44.2172,10.92 Z M56.8161,10.92\n  C56.4161,12.7 55.8561,13.26 54.5361,13.26 L51.7561,13.26 L51.7561,2.74 L53.6561,2.74 L53.6561,1 L47.0761,1 L47.0761,2.74 L48.7761,2.74 L48.7761,13.26 L47.0761,13.26\n  L47.0761,15 L58.4161,15 L58.4161,10.22 L56.9761,10.22 L56.8161,10.92 Z M67.3548,6.8 L64.8148,6.22 C63.3348,5.88 62.7148,5.3 62.7148,4.32 C62.7148,3.14 63.6548,2.4\n  65.4948,2.4 C67.3348,2.4 68.4148,3.06 68.8348,4.62 L69.0148,5.3 L70.4548,5.3 L70.4548,1.84 C68.8830796,1.03158224 67.1423274,0.606665867 65.3749,0.6 C61.9549,0.6\n  59.7549,2.24 59.7549,4.88 C59.7549,6.92 61.0349,8.42 63.4949,8.96 L66.0349,9.52 C67.6549,9.88 68.2549,10.52 68.2549,11.58 C68.2549,12.88 67.2749,13.6 65.3149,13.6\n  C63.0949,13.6 61.9549,12.72 61.4549,11.04 L61.1949,10.18 L59.7549,10.18 L59.7549,14.1 C61.5849502,15.0113218 63.6113126,15.4578084 65.6549,15.4 C69.0149,15.4 71.2149,13.72\n  71.2149,11.1 C71.2148,8.9 69.8747,7.38 67.3548,6.8 Z M86.6329,2.74 C87.9729,2.74 88.4329,3.32 88.8729,5 L89.0129,5.54 L90.4529,5.54 L90.4529,1 L78.3929,1 L78.3929,2.74 L80.0929,2.74\n  L80.0929,13.26 L78.3929,13.26 L78.3929,15 L85.0729,15 L85.0729,13.26 L83.0729,13.26 L83.0729,9.18 L87.1929,9.18 C87.3477086,8.86995608 87.4232935,8.52638836\n  87.4129,8.18 C87.4210727,7.84663029 87.3454276,7.51654256 87.1929,7.22 L83.0729,7.22 L83.0729,2.74 L86.6329,2.74 Z M117.1107,13.42 C117.350603,13.9403466\n  117.350603,14.5396534 117.1107,15.06 C116.593408,15.1270209 116.072315,15.1604243 115.5507,15.16 C113.6107,15.16 112.6707,14.36 112.4507,12.5 L112.3707,11.8 C112.1307,9.78\n  111.4707,9 109.2707,9 L108.1707,9 L108.1707,13.26 L110.0707,13.26 L110.0707,15 L97.4921,15 L97.4921,13.26 L99.1321,13.26 L98.2121,10.76 L93.0121,10.76 L92.0921,13.26 L93.7721,13.26\n  L93.7721,15 L88.4721,15 L88.4721,13.26 L89.8721,13.26 L94.772,1 L97.432,1 L102.432,13.26 L105.1907,13.26 L105.1907,2.74 L103.4907,2.74 L103.4907,1 L111.5307,1 C114.3907,1 116.2507,2.42\n  116.2507,4.7 C116.236826,5.65544044 115.842919,6.56599554 115.156084,7.23031176 C114.469248,7.89462798 113.546072,8.25797324 112.5907,8.24 L112.5907,8.3 C113.320265,8.29049748\n  114.022729,8.57612277 114.538653,9.09204674 C115.054577,9.60797071 115.340203,10.3104352 115.3307,11.04 L115.4107,11.78 C115.5307,12.94 115.7707,13.46 116.6907,13.46 C116.831581,13.4586084\n  116.972089,13.4452267 117.1107,13.42 Z M97.5719,9.06 L95.6119,3.76 L93.6519,9.06 L97.5719,9.06 Z M113.2307,4.98 C113.2307,3.52 112.3307,2.74 110.5307,2.74 L108.1707,2.74 L108.1707,7.24\n  L110.5307,7.24 C112.3108,7.24 113.2307,6.42 113.2307,4.98 Z M125.1745,8.62 C125.161819,8.96019815 125.237622,9.29786628 125.3945,9.6 L127.7745,9.6 L127.7745,13.14 C127.025969,13.4478108\n  126.223838,13.6041585 125.4145,13.6 C122.5345,13.6 121.0345,11.54 121.0345,7.98 C121.0345,4.42 122.5345,2.36 125.2545,2.36 C126.847915,2.27805546 128.291943,3.29300049 128.7545,4.82\n  L128.9745,5.38 L130.4145,5.38 L130.4145,1.8 C128.769872,0.975783763 126.954079,0.550956677 125.1145,0.56 C120.7145,0.56 117.7545,3.5 117.7545,8 C117.7545,12.52 120.6345,15.4 125.1145,15.4\n  C127.070757,15.3481445 128.988059,14.8414289 130.7145,13.92 L130.7145,7.68 L125.3945,7.68 C125.23997,7.96860667 125.164097,8.29279214 125.1745,8.62 Z M147.4382,7.98 C147.4382,12.0889985\n  144.107199,15.42 139.9982,15.42 C135.889201,15.42 132.5582,12.0889985 132.5582,7.98 C132.5582,3.87100146 135.889201,0.54 139.9982,0.54 C144.107199,0.54 147.4382,3.87100146 147.4382,7.98\n  Z M144.1582,7.98 C144.1582,4.44 142.6982,2.38 139.9982,2.38 C137.2982,2.38 135.8382,4.44 135.8382,7.98 C135.8382,11.54 137.2782,13.58 139.9982,13.58 C142.7182,13.58 144.1582,11.54 144.1582,7.98 Z\n";

var Logo = function Logo(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? '0' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '0' : _props$height,
      _props$x = props.x,
      x = _props$x === void 0 ? '' : _props$x,
      _props$y = props.y,
      y = _props$y === void 0 ? '0' : _props$y;
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 ".concat(width.replace('px', ''), " ").concat(height.replace('px', ''))
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(".concat(x, ", ").concat(y, ")")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: path,
    fillRule: "nonzero"
  })));
};

var getLogoSize = function getLogoSize(_ref) {
  var responsive = _ref.responsive,
      screenSize = _ref.screenSize,
      device = _ref.device;

  if (responsive) {
    switch (screenSize) {
      case 'small':
        return Object.assign({}, responsiveLogoSizes['sm'], responsiveLogoScales['sm']);

      case 'medium':
        return Object.assign({}, responsiveLogoSizes['md'], responsiveLogoScales['md']);

      case 'large':
      case 'xLarge':
        return Object.assign({}, responsiveLogoSizes['lg'], responsiveLogoScales['lg']);

      default:
        return Object.assign({}, responsiveLogoSizes['sm'], responsiveLogoScales['sm']);
    }
  }

  if (device.isMobile()) {
    return Object.assign({}, {
      width: '148px',
      height: '16px'
    }, responsiveLogoScales['sm']);
  }

  if (['medium', 'large', 'xLarge'].some(function (v) {
    return screenSize === v;
  })) {
    return Object.assign({}, {
      width: '211px',
      height: '22px'
    }, responsiveLogoScales['lg']);
  }

  return Object.assign({}, {
    width: '169px',
    height: '18px'
  }, responsiveLogoScales['md']);
};

var WellsFargoLogo = function WellsFargoLogo(_ref2) {
  var title = _ref2.title,
      className = _ref2.className,
      keepProps = _objectWithoutProperties(_ref2, ["title", "className"]);

  var brand = useBrand();
  var device = useDevice();
  var classNames = getClasses({
    styles: styles,
    classes: ['logo'],
    className: className,
    brand: brand
  });
  return /*#__PURE__*/React.createElement(MastheadContext.Consumer, null, function (_ref3) {
    var responsive = _ref3.responsive,
        screenSize = _ref3.screenSize;
    return /*#__PURE__*/React.createElement(Logo, _extends({}, Object.assign({}, keepProps, getLogoSize({
      responsive: responsive,
      screenSize: screenSize,
      device: device
    })), {
      className: classNames,
      title: title
    }));
  });
};

export default accessibleIcon(WellsFargoLogo);